import Header from '../Header/Header'
import herosection from '../../../assets/images/portfoliopage/herosection.webp'
import { motion } from 'framer-motion'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const PortfolioHeroSection = () => {
  return (
    <CommonHeroSection wrapperClassName="relative overflow-hidden">
      <div className="relative z-10">
        <Header />
      </div>

      <div className="relative flex min-h-[550px] items-center md:min-h-[500px] lg:min-h-[450px] 2xl:py-15">
  <div className="grid w-full grid-cols-1 items-center md:gap-10 md:grid-cols-2 lg:gap-6">

    {/* IMAGE */}
    <div className="order-1 flex w-full justify-center md:order-2 md:justify-end md:pr-[7%]">
      <motion.img
        src={herosection}
        alt="portfolio visual"
        className="pointer-events-none h-[240px] w-full object-contain opacity-95 sm:h-[300px] md:h-[360px] md:w-auto lg:h-[450px] xl:h-[50vh] 2xl:h-[60vh]"
        animate={{ y: [0, -20, 0] }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeIn',
        }}
      />
    </div>

    {/* CONTENT */}
    <div className="order-2 px-5 text-center md:order-1 md:ml-[10%] md:px-0 md:text-left">
      <h1 className="font-rajdhani text-4xl font-bold leading-[1.1] text-white md:text-4xl lg:text-5xl xl:text-[4vh] 2xl:text-[6vh]">
        Work That Delivers Results
      </h1>

      <p className="md:mt-5 font-gilroy-medium text-lg leading-[1.35] text-gray-400 md:text-lg lg:text-xl xl:text-3xl 2xl:text-4xl">
        Every project tells a story of challenges overcome and outcomes achieved.
        Explore how we've helped organizations like yours transform their
        technology.
      </p>
    </div>

  </div>
</div>
    </CommonHeroSection>
  )
}

export default PortfolioHeroSection